var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeditate = function SvgMeditate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.5 6.26A5.748 5.748 0 0 0 6.76 12a5.747 5.747 0 0 0 5.74 5.74A5.746 5.746 0 0 0 18.24 12a5.747 5.747 0 0 0-5.74-5.742Zm.001 15.615c-5.445 0-9.876-4.43-9.876-9.873 0-5.446 4.43-9.877 9.876-9.877 5.444 0 9.874 4.43 9.874 9.877 0 5.444-4.43 9.873-9.874 9.873Z",
    clipRule: "evenodd"
  })));
};
export default SvgMeditate;